<template>
  <div>
    <DxPopup
      :visible="visible"
      @hiding="onHiding"
      @shown="popupShown"
      :width="'80%'"
      :height="'80%'"
      :show-title="true"
      :title="popupTitle"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-close-button="true"
      :wrapperAttr="{ class: 'css-v2 gc-popup gc-popup-column-info' }"
    >
      <template #content>
        <div class="css-v2 transaction-list">
          <DxDataGrid
            :data-source="columnDetails"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :allow-column-resizing="true"
            :word-wrap-enabled="true"
            :pager="{ visible: false }"
            :column-chooser="{ enabled: false }"
          >
            <DxColumn data-field="name" caption="Name" :width="200" />
            <DxColumn data-field="description" caption="Description" />
            <DxScrolling mode="standard" />

            <DxPaging :page-size="50" :enabled="true" />
            <DxScrolling
              :mode="'virtual'"
              :row-rendering-mode="'virtual'"
              :preloadEnabled="true"
            />
            <DxSearchPanel :visible="false" />
          </DxDataGrid>
        </div>
      </template>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxPaging,
} from "devextreme-vue/data-grid";

export default {
  name: "ColumnDetailsPopup",
  components: {
    DxPopup,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popupTitle: "Column Details",
      columnDetails: [
        {
          name: "Estimate",
          description:
            "Initial expected volume for this variety-size based on intake estimate selected in the generation process.",
        },
        {
          name: "Completed",
          description:
            "Flag to indicate that this Variety has been marked complete and no further Intake is expected.",
        },
        {
          name: "Remaining",
          description:
            "The Remaining Volume of Intake that is still expected to be received against the variety / size. Calculated as (Estimate) - (Received to Date) at the time of data generation.",
        },
        {
          name: "Unreleased",
          description:
            "Intake Stock that has been cracked into bins, but not yet released into Gcorp inventory.",
        },
        {
          name: "Carry In",
          description:
            "Intake Stock cracked in previous seasons that has been carried into the selected season and not yet issued.",
        },
        {
          name: "On Hand",
          description:
            "Current available stock in Gcorp inventory, including carry-in but excluding unreleased bins.",
        },
        {
          name: "Total",
          description:
            "Represents total bulk stock available for use. Calculated as (Sum of On-Hand) + (Unreleased stock).",
        },
        {
          name: "O/S Sales Orders",
          description:
            "Volume committed to customers via sales orders not yet picked, grossed up by BOM Bulk Stock requirements.",
        },
        {
          name: "Undrawn Contracts",
          description:
            "Volume under contract that has not yet been drawn down, grossed up by BOM Bulk Stock requirements.",
        },
        {
          name: "O/S Sales Forecast",
          description:
            "Remaining Sales Forecast demand after accounting for Sales Contracts, Sales Orders, and Invoices, grossed up by BOM Bulk Stock requirements.",
        },
        {
          name: "Allocated",
          description:
            "Total Sales Order, Undrawn Contract & Sales Forecast volume, grossed up by BOM Bulk Stock requirements.",
        },
        {
          name: "Allocation %",
          description:
            "Percentage of available stock that has been allocated. Calculated as (Allocated) / (Remaining Estimate + On Hand + Unreleased) expressed as %.",
        },
        {
          name: "Unallocated",
          description:
            "Volume available but not yet committed. Calculated as (Remaining Estimate + On Hand + Unreleased) - Allocated Volume.",
        },
        {
          name: "Unallocated %",
          description:
            "Percentage of available stock that has not been. (Unallocated) / (Remaining Estimate + On Hand + Unreleased) expressed as %.",
        },
        {
          name: "Reclaim %",
          description:
            "The Production Reclaim % that is expected to be captured during processing as defined on the Intake Estimate selected during the generation process.",
        },
        {
          name: "Saleable",
          description:
            "Estimated volume available for sale after accounting for reclaim loss. Calculated as (Unallocated) x (100 - Reclaim %) / 100.",
        },
      ],
    };
  },
  methods: {
    onHiding() {
      this.$emit("update:visible", false);
    },
    popupShown(e) {
      this.$nextTick(() => {
        var content = e.component._$content;

        var popupHeight =
          content[0].querySelectorAll(".dx-popup-content")[0].clientHeight;

        var dataGridElement = content[0].querySelectorAll(
          ".dx-datagrid-rowsview"
        )[0];

        if (dataGridElement) {
          dataGridElement.style.height = `${popupHeight - 58}px`;
        }
      });
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
